// src/pages/VerifyOtpPage.js

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyOtp, resendOtp } from '../api/authApi';
import './VerifyOtpPage.css';

const VerifyOtpPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setEmail] = useState(location.state?.email || '');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
           await verifyOtp({ email, otp });
      setSuccess('Email verified! Redirecting to login...');

      const pendingSharedItinerarySave = sessionStorage.getItem('pendingSharedItinerarySave');

      setTimeout(() => {
        if (pendingSharedItinerarySave) {
          navigate('/login', {
            state: {
              from: '/my-itineraries',
              message: 'Log in to complete saving this shared itinerary.',
            },
          });
        } else {
          navigate('/login');
        }
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setSuccess('');
    if (!email) {
      setError('Please enter your email to resend OTP.');
      return;
    }
    try {
      await resendOtp(email);
      setSuccess('OTP resent to your email!');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
    <div className="auth-page-header">
    <div className="brand" onClick={() => navigate("/")}>
    <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
    <span className="brand-text">CUSTOM ROAM</span>
    </div>
        <div className="back-home" onClick={() => navigate('/')}>
          Back to Home
        </div>
      </div>
    <div className="verify-container">
      <h2>Verify Email</h2>
      <form onSubmit={handleVerify} className="verify-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="verify-input"
        />

        <input
          type="text"
          placeholder="Enter 6-digit OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          required
          className="verify-input"
        />

        {error && <p className="verify-error">{error}</p>}
        {success && <p className="verify-success">{success}</p>}

        <button type="submit" disabled={loading} className="verify-button">
          {loading ? 'Verifying...' : 'Verify'}
        </button>
      </form>

      <p className="verify-resend" onClick={handleResend}>
        Resend OTP
      </p>
    </div>
    </div>
  );
};

export default VerifyOtpPage;
